import { styled } from 'styled-components'

export const PromoSection = styled.div`
  padding: 12px 20px 24px;
`

export const EntryList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const PromoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const PromoLabel = styled.span`
  font-feature-settings: 'case' on;
  font-size: 11px;
  font-weight: 500;
  line-height: 170%;
  letter-spacing: 0.11px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.grayDark};
`

export const PromoCodeBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  height: 19px;
  padding: 0 7px 0 4px;
  border-radius: 4.764px;
  background: rgba(157, 157, 157, 0.1);

  font-size: 12.1px;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.596px;
  color: ${({ theme }) => theme.colors.black};

  svg {
    width: 17px;
    height: 17px;
    flex-shrink: 0;
  }
`

export const AddPromoLink = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  font-feature-settings: 'case' on;
  font-size: 13px;
  font-weight: 400;
  line-height: 150%;
  color: ${({ theme }) => theme.colors.grayDark};
  text-decoration: underline;
  text-decoration-skip-ink: none;
  text-underline-position: from-font;
`

export const DiscountAppliedRow = styled.div<{ $isPromo: boolean }>`
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: ${({ $isPromo }) => ($isPromo ? '5px' : '1px')};
  font-size: 15px;
  font-weight: 500;
  line-height: 150%;
  color: ${({ theme }) => theme.colors.primary};

  svg {
    width: 17px;
    height: 17px;
  }
`

export const DiscountDescription = styled.div`
  margin-top: 4px;
  font-size: 15px;
  font-weight: 500;
  line-height: 150%;
  color: ${({ theme }) => theme.colors.black};
`

export const DiscountProgressBarContainer = styled.div`
  margin-top: 8px;
`
